import React, { Component } from 'react'
import './index.css'
export default class Header extends Component {
    render() {
        return (
            <div className='header-container no-mobo'>
                <ul className='header-grid' >
                    <li>
                        <a className="no-deco" href="#infosection" >INFO</a>
                    </li>

                    <li>
                        <a className="no-deco" href="https://quickspeech-in.web.app" target='_blank' >CONTRIBUTE</a>
                    </li>

                    <li>
                    <a className="no-deco" href="#samples" >SAMPLES</a>
                    </li>

                    <li>
                    <a className="no-deco" href="https://play.google.com/store/apps/details?id=com.scibots.rakshak" >APP</a>
                    </li>

                    <li>
                    <a className="no-deco" href="#paperpublishedsection" >RESEARCH</a>
                    </li>
                    <li>
                    <a className="no-deco" href="#about" >ABOUT</a>
                    </li>
                </ul>
            </div>
        )
    }
}
